import {Component, model, OnDestroy} from '@angular/core';
import {Subscription} from "rxjs";
import {FormBuilder, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {AlertService} from "../../../../common/alert/alert.service";
import {AlertComponent} from "../../../../common/alert/alert.component";
import {NgClass, NgIf} from "@angular/common";
import {PinholePromoCodeService, PromoCode} from "../../services/pinhole.promo-code.service";

@Component({
    selector: 'look-up',
    templateUrl: './look-up.component.html',
    imports: [
        ReactiveFormsModule,
        AlertComponent,
        NgIf,
        NgClass
    ],
    styleUrls: ['look-up.component.css'],
    providers: [AlertService]
})
export class LookUpComponent implements OnDestroy {
    private formBuilder = new FormBuilder().nonNullable
    private code = this.formBuilder.control("")
    private subscriptions: Subscription[] = [];

    isLoading: boolean = false;
    lookUpForm = new FormGroup({
        code: this.code,
    });

    readonly promoCode = model<PromoCode | null>(null);

    constructor(private service: PinholePromoCodeService, private alertService: AlertService) {

    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe())
    }

    lookUp() {
        this.alertService.clearAlerts();
        this.isLoading = true;
        this.promoCode.set(null);
        this.subscriptions.push(
            this.service
                .findPromoCode(this.code.value.toUpperCase())
                .subscribe(value => {
                    this.isLoading = false;
                    if (value != null) {
                        this.promoCode.set(value);
                    } else {
                        this.alertService.showAlert('danger', "Not found");
                    }
                })
        );
    }
}
